


















































import Vue from 'vue'
import Gallery from '@/components/organisms/Gallery.vue'
import AddToBasket from '@/components/organisms/AddToBasket.vue'
import TextContainer from '@/components/atoms/TextContainer.vue'
import SubNavigation from '@/components/molecules/SubNavigation.vue'
const axios = require('axios')
axios.defaults.headers.common['sw-access-key'] = 'SWSCMWJBBGXYT3BMV0M0TE16WG'
export default Vue.extend({
  name: 'ProductDetails',
  components: { SubNavigation, TextContainer, AddToBasket, Gallery },
  data () {
    return {
      info: null,
      name: null,
      description: null,
      productNumber: null,
      stock: null,
      priceGross: null,
      taxName: null,
      firstImageUrl: null
    }
  },
  mounted () {
    axios
      .get('https://api.2pd.eu/product/' + this.$route.params.id + '?associations[media][]')
      // eslint-disable-next-line no-return-assign
      .then((response: any) => (
        this.info = response,
        this.name = response.data.data.name,
        this.description = response.data.data.description,
        this.productNumber = response.data.data.productNumber,
        this.stock = response.data.data.stock,
        this.priceGross = response.data.data.calculatedPrice.totalPrice,
        this.taxName = response.data.data.tax.name,
        this.firstImageUrl = response.data.data.media[0].media.thumbnails[0].url
      ))
  }
})
